import Link from "next/link";
import React, { useEffect, useState } from "react";
import {
  getDownload,
  getInitialData,
  getProduct,
} from "../../../../service/apiFetch";
import Innerhtml from "../../../../components/utils/Innerhtml";
import WsrvImage from "../../../../components/utils/WsrvImage";
import { getWsrvUrl } from "../../../../utils/wsrv";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaDownload } from "react-icons/fa6";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import "./styles.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};
export const getStaticProps = async (context) => {
  const { uri } = context.params;
  console.log(uri, "url");

  try {
    const initialData = await getInitialData(`courses/details/${uri}`, {
      populate: "linkedProduct",
    });

    return {
      props: {
        websiteData: initialData?.websiteData || "",
        data: initialData?.data || { contentBlock: {} },
        title: initialData?.title || "",
        metaTags: initialData?.metaTags || "",
        url: initialData?.url || "",
      },
    };
  } catch (error) {
    console.error("API fetch failed:", error);
    return {
      props: {
        data: { contentBlock: {} },
      },
    };
  }
};

export default function index({ data }) {
  const [comobsProducts, setCombosProducts] = useState([]);
  const [combosLoading, setCombosLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState([]);
  const [open, setOpen] = useState(false);
  const [fullDescription, setFullDescription] = useState("");
  useEffect(() => {
    const combosId = data?.linkedProduct?.comboProducts;

    if (combosId && combosId.length > 0) {
      (async () => {
        setCombosLoading(true);
        try {
          const ids = Array.isArray(combosId) ? combosId.join(",") : combosId;
          const params = {
            ids: ids,
          };
          const response = await getProduct(params);
          setCombosProducts(response || []);
        } catch (error) {
          console.error("Error fetching combo products:", error);
        } finally {
          setCombosLoading(false);
        }
      })();
    }
  }, [data]);

  const downloadCategory = data?.freeResources?.downloadCategory;

  const downloadLink = async () => {
    if (!downloadCategory) return;

    try {
      const params = new URLSearchParams({
        category: downloadCategory,
        select: "fileUrl",
      });

      const downloadRes = await getDownload(params);
      // console.log("downloadres", downloadRes);

      if (
        Array.isArray(downloadRes) &&
        downloadRes.length > 0 &&
        downloadRes[0]?.fileUrl
      ) {
        setFileUrl(downloadRes[0].fileUrl);
      }
    } catch (error) {
      console.error("Error fetching download link:", error);
    }
  };

  useEffect(() => {
    if (downloadCategory) {
      downloadLink();
    }
  }, [downloadCategory]);

  return (
    <>
      <div className="bg-[#f2faff] mt-1">
        {/* {JSON.stringify(data)} */}
        <div className="container  py-4">
          <div className="grid lg:grid-cols-9 grid-cols-1 gap-8 py-6">
            {(data?.linkedProduct?.title ||
              data?.linkedProduct?.description) && (
                <div className="lg:col-span-5">
                  <div
                    className="bg-white bg-no-repeat bg-cover h-[54px] w-[190px] flex justify-center items-center"
                    style={{
                      backgroundImage: `url('${getWsrvUrl(
                        "https://i.filecdn.in/807clcworld/bg-image-1745569973427.png",
                        { w: 400, q: 80 }
                      )}')`,
                    }}
                  >
                    <p className="text-2xl font-bold text-black ">Best Seller</p>
                  </div>
                  <h1 className="lg:text-4xl text-3xl font-bold mt-4">
                    {data?.linkedProduct?.title}
                  </h1>
                  <div className="text-[#6c757d] text-lg text-justify">
                    <Innerhtml data={data?.linkedProduct?.description} />
                  </div>
                </div>
              )}

            <>
              {(data?.linkedProduct?.cost || data?.linkedProduct?.featureImg || data?.linkedProduct) && (
                <div className="lg:col-span-4 lg:sticky lg:top-24 lg:self-start">
                  <div className="bg-[#f2faff]">
                    <div className="relative pb-[55.5556%]">
                      <WsrvImage
                        src={data?.linkedProduct?.featureImg}
                        alt={data?.linkedProduct?.title || "Course Image"}
                        width={600}
                        height={340}
                        preset="card"
                        sizes="(max-width: 1024px) 100vw, 600px"
                        className="absolute top-0 left-0 w-full h-full object-cover"
                      />
                    </div>

                    <div className="mt-4">
                      <div
                        className={`mb-2 bg-[#FFF7EB] py-3  px-3 rounded-md flex items-center justify-center  gap-1 `}
                      >
                        <span className="lg:text-[28.99px] text-xl font-medium text-gray-900">
                          {/* <sup className="lg:text-[16.19px] text-sm mx-1">
                         
                          </sup> */}
                          ₹ {data?.linkedProduct?.cost}
                        </span>
                        {/* <span className="text-sm lg:text-[17.81px] text-start font-[400] text-gray-700">
                          Online Test Series
                        </span> */}
                      </div>
                      <div className="">
                        <div className="border-b-0">
                          <Link
                            href={`/buy/${data?.linkedProduct?.id}`}
                            className="w-full bg-yellow-400 inline-block text-center lg:text-[16.19px] text-sm hover:bg-yellow-500 text-gray-900 py-3 px-4 rounded-lg font-medium mb-4 transition-colors"
                          >
                            <span className="text font-[800]">Buy Now</span>
                          </Link>
                        </div>
                      </div>
                      <div className="border-b-0"></div>
                    </div>
                  </div>

                  {downloadCategory && (
                    <div className="flex gap-2 items-center lg:text-2xl text-xl text-[#046635] justify-center">
                      <FaDownload />
                      <Link href={fileUrl} target="_blank">
                        Schedule & Syllabus
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </>
          </div>
          {data?.more?.content && (
            <div className="text-[#6c757d] text-lg text-justify w-full mt-4">
              <Innerhtml data={data?.more?.content} />
            </div>
          )}
        </div>

        {combosLoading && (
          <div className="container max-w-[1400px] mx-auto py-8 px-4 animate-pulse">
            <div className="flex gap-5 overflow-hidden">
              {[1,2,3,4].map(i => (
                <div key={i} className="flex-shrink-0 w-60">
                  <div className="h-36 bg-gray-200 rounded-lg mb-3" />
                  <div className="h-5 bg-gray-200 rounded w-3/4" />
                </div>
              ))}
            </div>
          </div>
        )}
        {!combosLoading && comobsProducts.length > 0 && (
          <div className="container  max-w-[1400px] mx-auto py-8 px-4">
            {/* <h3 className="text-2xl font-semibold mb-6 text-center sm:text-left">
            Latest Courses
          </h3> */}

            <Swiper
              spaceBetween={20}
              centeredSlides={false}
              autoplay={{
                delay: 3500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                320: { slidesPerView: 1 },
                480: { slidesPerView: 1.2 },
                640: { slidesPerView: 1.5 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
              pagination={{ clickable: true }}
              modules={[Autoplay, Pagination, Navigation]}
              className="mySwiper"
            >
              {comobsProducts.map((item, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="bg-white   overflow-hidden"
                    onClick={() => {
                      setFullDescription(item.fullDescription);
                      setOpen(true);
                    }}
                  >
                    <div className="relative pt-[56.4972%] rounded-t-[30px] overflow-hidden">
                      <WsrvImage
                        src={item.thumb}
                        alt={item.title || "Course thumb"}
                        width={400}
                        height={230}
                        preset="card"
                        sizes="(max-width: 768px) 50vw, 400px"
                        className="absolute top-0 left-0 w-full h-full object-contain"
                      />
                    </div>
                    <div className="px-4 py-4">
                      <h4 className="text-lg font-semibold text-center sm:text-left">
                        {item.title}
                      </h4>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>

      {/* {JSON.stringify(comobsProducts)} */}

      {open && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 "
          onClick={() => setOpen(false)}
        >
          <div
            className="bg-white p-6 rounded-2xl max-w-6xl w-full shadow-lg relative max-h-[600px] overflow-scroll"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-black"
            >
              ✕
            </button>

            {/* Full text */}
            <div className="text-black text-lg leading-[42px] font-medium">
              <Innerhtml data={fullDescription} />
              {/* {fullDescription} */}
            </div>
          </div>
        </div>
      )}

      <Innerhtml />
    </>
  );
}
